export default "__VITE_ASSET__DnJYdYPl__"